export { default } from './BlogSharedHeader';
